import { Component, EventEmitter, Inject, Input, OnDestroy, Output } from '@angular/core';

import { Subscription, interval, of } from 'rxjs';
import { map, mergeMap, startWith } from 'rxjs/operators';
import { JobService } from '../services/job.service';
import { JobProgressStatus, JobStatus } from '../entities/job-progress-status.entity';

@Component({
	selector: 'job-progress',
	templateUrl: 'job-progress.html',
	// styleUrls: ['job-progress.css'],
})
export class JobProgressComponent implements OnDestroy {
	private timeSubscription: Subscription | null = null;
	jobProgress: JobProgressStatus | null = null;
	status = JobStatus;

	constructor(
		@Inject(JobService) private jobService: JobService
	) {
	}
	
	@Input() set jobExecutionId(executionId: number | null) {
		this.jobProgress = null;
		this.timeSubscription?.unsubscribe();
		this.timeSubscription = null;
		
		if (executionId) {
			// Toutes les secondes obtenir un status a jour
			this.timeSubscription = interval(1000)
				.pipe(
					startWith(0),
					mergeMap(
						(_) => this.jobService.getProgress(executionId)
					)
				)
				.subscribe({
					next: (jobProgressStatus) => {
						this.jobProgress = jobProgressStatus;
						
						// Si le job devient ne reporte plus un status "en cours", retirer la subscription
						if (
							jobProgressStatus 
							&& jobProgressStatus.status !== JobStatus.ONGOING
							&& jobProgressStatus.status !== JobStatus.UNKNOWN
						) {
							this.timeSubscription?.unsubscribe();
							this.timeSubscription = null;
							this.jobCompleted.emit(jobProgressStatus.status !== JobStatus.FAILED);
						}
					},
					error: (errorData) => {
						console.error("JobProgressComponent - " + new Date() + " - ERROR!", errorData);
					}
				})
			;
		}
	}

	@Output() jobCompleted = new EventEmitter<boolean>();
	
	ngOnDestroy() {
		this.timeSubscription?.unsubscribe();
	}
}